<template>
  <div class="s-submit-wrapper" :class="[`s-submit-wrapper--${position}`]">
    <slot />
    <PMessage v-if="status === 'error'" severity="error" :size>
      {{ errorMessage || tr("general.error.submit_error") }}
    </PMessage>
    <PMessage
      v-if="status === 'success' && successMessage"
      severity="success"
      :size
    >
      {{ successMessage }}
    </PMessage>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

/**
 * Wrapper that displays success/error messages based on form submission status.
 * Shows translated messages when status changes. Position controls message placement.
 */
import { useI18nGeneral } from "@solvari/translations";

import PMessage from "@/atoms/PMessage.vue";

const props = withDefaults(
  defineProps<{
    errorMessage?: string;
    position?: "bottom" | "left" | "right" | "top";
    size?: "lg" | "sm";
    status: "error" | "idle" | "pending" | "success";
    successMessage?: string;
  }>(),
  { position: "bottom" },
);

const { tr } = useI18nGeneral();

const successMessage = computed(() => {
  if (props.successMessage || props.successMessage === "") {
    return props.successMessage;
  }
  return tr("general.error.submit_success");
});
</script>

<style lang="postcss">
.s-submit-wrapper {
  @apply flex gap-2;

  &--bottom {
    @apply flex-col;
  }

  &--top {
    @apply flex-col flex-col-reverse;
  }

  &--left {
    @apply flex-row-reverse;
  }
}
</style>
